// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1_A-D","icon":"SortAdornment_icon__1E1s_","up":"SortAdornment_up__3DCYR","down":"SortAdornment_down__1q4QM","active":"SortAdornment_active__1bTIW"};